// tesi-configurator.js - VERSIONE MIGLIORATA
document.addEventListener('DOMContentLoaded', function() {
  initializeConfigurator();
});

// Dati dei materiali e colori
const materialData = {
  'similpelle-liscia': {
    name: 'Similpelle Liscia',
    colors: ['Petrolio', 'Verde mare', 'Tiffany', 'Giallo Limone', 'Rosso', 'Rosa Antico', 'Glicine', 'Viola Cloudy', 'Ghiaccio'],
    description: 'Similpelle liscia di alta qualità, perfetta per una finitura elegante e moderna.',
    category: 'similpelle'
  },
  'similpelle-venata': {
    name: 'Similpelle Venata',
    colors: ['Bianco Puro', 'Tortora', 'Cammello', 'Cuoio', 'Rosso', 'Vinaccia', 'Blu scuro', 'Blu Elettrico', 'Verde', 'Nero'],
    description: 'Similpelle con effetto venatura naturale, ideale per un look classico e raffinato.',
    category: 'similpelle'
  },
  'similpelle-marmorizzata': {
    name: 'Similpelle Marmorizzata',
    colors: ['Avorio', 'Tortora', 'Cuoio', 'Rosso', 'Bordeaux', 'Blu Scuro', 'Verde'],
    description: 'Effetto marmo elegante per una tesi dal design unico e ricercato.',
    category: 'similpelle'
  },
  'similpelle-tinta-unita': {
    name: 'Similpelle Tinta Unita',
    colors: ['Bianco Perlato', 'Giallo', 'Ocra', 'Viola', 'Blu Elettrico', 'Blu Navy Lucida', 'Nero Opaco'],
    description: 'Colori solidi e vibranti per un impatto visivo immediato.',
    category: 'similpelle'
  },
  'similpelle-effetto-seta': {
    name: 'Similpelle Effetto Seta',
    colors: ['Rosso', 'Blu', 'Verde', 'Champagne', 'Rosa'],
    description: 'Finitura setata che dona un effetto di luce e profondità unico.',
    category: 'similpelle'
  },
  'raso': {
    name: 'Raso',
    colors: ['Rosso', 'Bordeaux', 'Viola'],
    description: 'Tessuto di raso pregiato, lucido e elegante.',
    category: 'tessuto'
  },
  'velluto': {
    name: 'Velluto',
    colors: ['Rosso', 'Blu', 'Vinaccia'],
    description: 'Velluto morbido e lussuoso per una finitura premium.',
    category: 'tessuto'
  },
  'seta': {
    name: 'Seta',
    colors: ['Blu', 'Vinaccia', 'Nero'],
    description: 'Tessuto di seta naturale, il massimo della raffinatezza.',
    category: 'tessuto'
  }
};

// Variabili globali
let orderData = {
  material: { id: '', name: '', category: '', color: '' },
  printColor: 'oro',
  printType: 'solo-fronte',
  printInternal: 'bianco-nero',
  paperWeight: '80',
  totalPages: 0,
  colorPages: 0,
  copies: 1,
  uploadedFiles: [],
  customerName: '',
  customerEmail: '',
  customerPhone: '',
  shippingRequired: false,
  shippingAddress: '',
  shippingZip: '',
  shippingProvince: ''
};

// Prezzi
const paperPrices = {
  '80': { bw: 0.05, color: 0.30 },
  '90': { bw: 0.06, color: 0.30 },
  '100': { bw: 0.08, color: 0.30 },
  '120': { bw: 0.10, color: 0.45 }
};

// Costo spedizione
const SHIPPING_COST = 8.90;
const FREE_SHIPPING_THRESHOLD = 59.00;

function initializeConfigurator() {
  console.log('🔄 Inizializzazione configuratore...');
  setupMaterialSelection();
  setupPrintingOptions();
  setupDocumentInput();
  setupCopiesSelection();
  setupShippingToggle();
  updateProgressBar(1);
  console.log('✅ Configuratore inizializzato');
}

function setupMaterialSelection() {
  const materialSelect = document.getElementById('material-category');
  const colorSelect = document.getElementById('material-color');
  const printColorSelect = document.getElementById('print-color');
  
  materialSelect.addEventListener('change', function() {
    const materialId = this.value;
    
    colorSelect.disabled = !materialId;
    
    if (materialId) {
      updateColorOptions(materialId);
      orderData.material.id = materialId;
      orderData.material.name = materialData[materialId].name;
      orderData.material.category = materialData[materialId].category;
      updatePricingTiers(materialId);
      
      // Se è un tessuto, rimuovi l'opzione bianco
      if (materialData[materialId].category === 'tessuto') {
        const whiteOption = printColorSelect.querySelector('option[value="bianco"]');
        if (whiteOption) {
          whiteOption.disabled = true;
          if (printColorSelect.value === 'bianco') {
            printColorSelect.value = 'oro';
            orderData.printColor = 'oro';
          }
        }
      } else {
        // Riabilita tutte le opzioni per similpelle
        printColorSelect.querySelectorAll('option').forEach(option => {
          option.disabled = false;
        });
      }
    } else {
      clearColorOptions();
    }
    
    updateSelectedMaterialsDisplay();
    calculatePrice();
  });
  
  colorSelect.addEventListener('change', function() {
    if (this.value) {
      orderData.material.color = this.value;
      updateSelectedMaterialsDisplay();
      calculatePrice();
    }
  });
  
  printColorSelect.addEventListener('change', function() {
    orderData.printColor = this.value;
    updateSelectedMaterialsDisplay();
  });
}

function updatePricingTiers(materialId) {
  const pricingTiers = document.getElementById('pricing-tiers');
  if (!pricingTiers) return;
  
  const material = materialData[materialId];
  
  if (material.category === 'tessuto') {
    pricingTiers.innerHTML = `
      <div class="pricing-tier">
        <span class="tier-range">1° copia</span>
        <span class="tier-price">€28.00</span>
      </div>
      <div class="pricing-tier">
        <span class="tier-range">2° copia</span>
        <span class="tier-price">€25.00</span>
      </div>
      <div class="pricing-tier">
        <span class="tier-range">Dalla 3° alla 5° copia</span>
        <span class="tier-price">€23.00/copia</span>
      </div>
      <div class="pricing-tier">
        <span class="tier-range">Dalla 6° copia in poi</span>
        <span class="tier-price">€20.00/copia</span>
      </div>
    `;
  } else {
    pricingTiers.innerHTML = `
      <div class="pricing-tier">
        <span class="tier-range">1° copia</span>
        <span class="tier-price">€20.00</span>
      </div>
      <div class="pricing-tier">
        <span class="tier-range">2° copia</span>
        <span class="tier-price">€18.00</span>
      </div>
      <div class="pricing-tier">
        <span class="tier-range">Dalla 3° alla 5° copia</span>
        <span class="tier-price">€15.00/copia</span>
      </div>
      <div class="pricing-tier">
        <span class="tier-range">Dalla 6° copia in poi</span>
        <span class="tier-price">€13.00/copia</span>
      </div>
    `;
  }
}

function updateColorOptions(materialId) {
  const colorSelect = document.getElementById('material-color');
  const material = materialData[materialId];
  
  colorSelect.innerHTML = '<option value="">Seleziona colore</option>';
  
  material.colors.forEach(color => {
    const option = document.createElement('option');
    option.value = color;
    option.textContent = color;
    colorSelect.appendChild(option);
  });
  
  colorSelect.disabled = false;
}

function clearColorOptions() {
  const colorSelect = document.getElementById('material-color');
  colorSelect.innerHTML = '<option value="">Prima seleziona il materiale</option>';
  colorSelect.disabled = true;
}

function updateSelectedMaterialsDisplay() {
  const display = document.getElementById('selected-materials');
  
  if (orderData.material.id && orderData.material.color) {
    display.innerHTML = `
      <p><strong>Materiale:</strong> ${orderData.material.name}</p>
      <p><strong>Colore:</strong> ${orderData.material.color}</p>
      <p><strong>Stampa:</strong> ${getPrintColorName(orderData.printColor)}</p>
    `;
  } else {
    display.innerHTML = '<p>Nessun materiale selezionato</p>';
  }
}

function getPrintColorName(colorValue) {
  const colorNames = {
    'oro': 'Oro',
    'argento': 'Argento',
    'bronzo': 'Bronzo',
    'bianco': 'Bianco',
    'nero': 'Nero',
    'blu-metal': 'Blu Metal',
    'rosso-metal': 'Rosso Metal',
    'verde-metal': 'Verde Metal',
    'rosa-metal': 'Rosa Metal'
  };
  return colorNames[colorValue] || colorValue;
}

function setupPrintingOptions() {
  document.querySelectorAll('input[name="Tipo di Stampa"]').forEach(radio => {
    radio.addEventListener('change', function() {
      orderData.printType = this.value;
      calculatePrice();
    });
  });
  
  document.querySelectorAll('input[name="Stampa Interna"]').forEach(radio => {
    radio.addEventListener('change', function() {
      orderData.printInternal = this.value;
      const colorPagesInput = document.getElementById('color-pages-input');
      const colorPagesGroup = document.getElementById('color-pages-group');
      
      if (this.value === 'bianco-nero') {
        colorPagesInput.disabled = true;
        colorPagesInput.value = '';
        colorPagesGroup.style.opacity = '0.6';
        orderData.colorPages = 0;
      } else {
        colorPagesInput.disabled = false;
        colorPagesGroup.style.opacity = '1';
      }
      
      updatePageCount();
    });
  });
  
  const paperWeightSelect = document.getElementById('paper-weight');
  paperWeightSelect.addEventListener('change', function() {
    orderData.paperWeight = this.value;
    calculatePrice();
  });
  
  const totalPagesInput = document.getElementById('total-pages-input');
  const colorPagesInput = document.getElementById('color-pages-input');
  
  totalPagesInput.addEventListener('input', updatePageCount);
  colorPagesInput.addEventListener('input', updatePageCount);
}

function updatePageCount() {
  const totalPagesInput = document.getElementById('total-pages-input');
  const colorPagesInput = document.getElementById('color-pages-input');
  
  const totalPages = parseInt(totalPagesInput.value) || 0;
  const colorPages = parseInt(colorPagesInput.value) || 0;
  
  orderData.totalPages = totalPages;
  
  if (orderData.printInternal === 'bianco-nero') {
    orderData.colorPages = 0;
  } else {
    orderData.colorPages = Math.min(colorPages, totalPages);
  }
  
  calculatePrice();
}

function setupDocumentInput() {
  const uploadArea = document.getElementById('upload-area');
  const fileInput = document.getElementById('thesis-file');
  
  uploadArea.addEventListener('click', function() {
    fileInput.click();
  });
  
  fileInput.addEventListener('change', function(e) {
    if (e.target.files.length > 0) {
      handleFilesUpload(Array.from(e.target.files));
    }
  });
  
  uploadArea.addEventListener('dragover', function(e) {
    e.preventDefault();
    uploadArea.classList.add('dragover');
  });
  
  uploadArea.addEventListener('dragleave', function(e) {
    e.preventDefault();
    uploadArea.classList.remove('dragover');
  });
  
  uploadArea.addEventListener('drop', function(e) {
    e.preventDefault();
    uploadArea.classList.remove('dragover');
    
    if (e.dataTransfer.files.length > 0) {
      handleFilesUpload(Array.from(e.dataTransfer.files));
    }
  });
}

function handleFilesUpload(files) {
  const allowedTypes = ['application/pdf'];
  const maxTotalSize = 50 * 1024 * 1024; // 50MB totali
  const maxFiles = 4;
  
  // Calcola la dimensione totale attuale
  const currentTotalSize = orderData.uploadedFiles.reduce((total, file) => total + file.size, 0);
  const newFilesTotalSize = files.reduce((total, file) => total + file.size, 0);
  
  if (orderData.uploadedFiles.length + files.length > maxFiles) {
    alert(`Puoi caricare massimo ${maxFiles} file. Hai già caricato ${orderData.uploadedFiles.length} file.`);
    return;
  }
  
  if (currentTotalSize + newFilesTotalSize > maxTotalSize) {
    alert(`La dimensione totale dei file non può superare i 50MB. Dimensione attuale: ${(currentTotalSize / 1024 / 1024).toFixed(2)}MB, nuovi file: ${(newFilesTotalSize / 1024 / 1024).toFixed(2)}MB.`);
    return;
  }
  
  const validFiles = files.filter(file => {
    const isValidType = allowedTypes.includes(file.type);
    
    if (!isValidType) {
      alert(`Tipo di file non supportato: ${file.name}. Usa solo PDF.`);
      return false;
    }
    
    return true;
  });
  
  if (validFiles.length === 0) return;
  
  orderData.uploadedFiles = orderData.uploadedFiles.concat(validFiles);
  updateFilesPreview();
  
  if (orderData.uploadedFiles.length > 0) {
    document.getElementById('upload-area').style.display = 'none';
  }
}

function updateFilesPreview() {
  const filePreview = document.getElementById('file-preview');
  const filesList = document.getElementById('files-list');
  
  filesList.innerHTML = '';
  
  orderData.uploadedFiles.forEach((file, index) => {
    const fileElement = document.createElement('div');
    fileElement.className = 'file-item';
    fileElement.innerHTML = `
      <div class="file-info">
        <span class="file-name">${file.name}</span>
        <span class="file-size">(${(file.size / 1024 / 1024).toFixed(2)} MB)</span>
      </div>
      <button type="button" class="remove-file" onclick="removeFile(${index})">✕</button>
    `;
    filesList.appendChild(fileElement);
  });
  
  filePreview.style.display = orderData.uploadedFiles.length > 0 ? 'block' : 'none';
}

function removeFile(index) {
  orderData.uploadedFiles.splice(index, 1);
  updateFilesPreview();
  
  if (orderData.uploadedFiles.length === 0) {
    document.getElementById('upload-area').style.display = 'block';
  }
}

function setupCopiesSelection() {
  const copiesCount = document.getElementById('copies-count');
  copiesCount.addEventListener('change', function() {
    orderData.copies = parseInt(this.value) || 1;
    calculatePrice();
  });
}

function increaseCopies() {
  const input = document.getElementById('copies-count');
  input.value = parseInt(input.value) + 1;
  orderData.copies = parseInt(input.value);
  calculatePrice();
}

function decreaseCopies() {
  const input = document.getElementById('copies-count');
  if (parseInt(input.value) > 1) {
    input.value = parseInt(input.value) - 1;
    orderData.copies = parseInt(input.value);
    calculatePrice();
  }
}

function setupShippingToggle() {
  const shippingCheckbox = document.getElementById('shipping-required');
  const shippingFields = document.querySelectorAll('.shipping-fields');
  
  shippingCheckbox.addEventListener('change', function() {
    orderData.shippingRequired = this.checked;
    
    shippingFields.forEach(field => {
      field.style.display = this.checked ? 'block' : 'none';
    });
    
    calculatePrice();
  });
}

function calculatePrice() {
  if (!orderData.material.id || orderData.totalPages === 0) return;
  
  const paperPrice = paperPrices[orderData.paperWeight];
  
  let effectiveBwPages = orderData.totalPages - orderData.colorPages;
  let effectiveColorPages = orderData.colorPages;
  
  if (orderData.printInternal === 'bianco-nero') {
    effectiveBwPages = orderData.totalPages;
    effectiveColorPages = 0;
  }
  
  const bwCost = effectiveBwPages * paperPrice.bw;
  const colorCost = effectiveColorPages * paperPrice.color;
  const coverCost = calculateCoverPrice();
  
  let total = (bwCost + colorCost) * orderData.copies + coverCost;
  
  let shippingCost = 0;
  if (orderData.shippingRequired && total < FREE_SHIPPING_THRESHOLD) {
    shippingCost = SHIPPING_COST;
  }
  
  total += shippingCost;
  const roundedTotal = Math.ceil(total * 10) / 10;
  
  updateElementText('price-bw', `€${(bwCost * orderData.copies).toFixed(2)}`);
  updateElementText('price-color', `€${(colorCost * orderData.copies).toFixed(2)}`);
  updateElementText('price-covers', `€${coverCost.toFixed(2)}`);
  updateElementText('price-shipping', `€${shippingCost.toFixed(2)}`);
  updateElementText('price-total', `€${roundedTotal.toFixed(2)}`);
  updateElementText('binding-total-price', `€${coverCost.toFixed(2)}`);
  
  // Calcola e mostra il prezzo per copia
  updatePricePerCopy(roundedTotal);
  
  // Mostra/nascondi il banner promozionale
  updatePromotionalBanner(roundedTotal);
}

function updatePricePerCopy(totalPrice) {
  const pricePerCopyContainer = document.getElementById('price-per-copy-container');
  const pricePerCopyElement = document.getElementById('price-per-copy');
  
  if (orderData.copies > 1) {
    const pricePerCopy = totalPrice / orderData.copies;
    pricePerCopyElement.textContent = `€${pricePerCopy.toFixed(2)}`;
    pricePerCopyContainer.style.display = 'block';
  } else {
    pricePerCopyContainer.style.display = 'none';
  }
}

function updatePromotionalBanner(currentTotal) {
  const promotionalBanner = document.getElementById('promotional-banner');
  const savingsMessage = document.getElementById('savings-message');
  
  if (orderData.copies >= 1 && orderData.copies < 6) {
    const nextCopies = orderData.copies + 1;
    const nextTotal = calculateTotalForCopies(nextCopies);
    const currentPerCopy = currentTotal / orderData.copies;
    const nextPerCopy = nextTotal / nextCopies;
    const savingsPerCopy = currentPerCopy - nextPerCopy;
    
    if (savingsPerCopy > 0) {
      savingsMessage.textContent = `Con ${nextCopies} copie risparmieresti €${savingsPerCopy.toFixed(2)} su ogni copia!`;
      promotionalBanner.style.display = 'block';
    } else {
      promotionalBanner.style.display = 'none';
    }
  } else {
    promotionalBanner.style.display = 'none';
  }
}

function calculateTotalForCopies(copies) {
  const paperPrice = paperPrices[orderData.paperWeight];
  
  let effectiveBwPages = orderData.totalPages - orderData.colorPages;
  let effectiveColorPages = orderData.colorPages;
  
  if (orderData.printInternal === 'bianco-nero') {
    effectiveBwPages = orderData.totalPages;
    effectiveColorPages = 0;
  }
  
  const bwCost = effectiveBwPages * paperPrice.bw;
  const colorCost = effectiveColorPages * paperPrice.color;
  const coverCost = calculateCoverPriceForCopies(copies);
  
  let total = (bwCost + colorCost) * copies + coverCost;
  
  let shippingCost = 0;
  if (orderData.shippingRequired && total < FREE_SHIPPING_THRESHOLD) {
    shippingCost = SHIPPING_COST;
  }
  
  total += shippingCost;
  return Math.ceil(total * 10) / 10;
}

function calculateCoverPriceForCopies(copies) {
  const { category } = orderData.material;
  
  if (category === 'tessuto') {
    if (copies === 1) return 28.00;
    if (copies === 2) return 28.00 + 25.00;
    if (copies >= 3 && copies <= 5) return 28.00 + 25.00 + (copies - 2) * 23.00;
    if (copies >= 6) return 28.00 + 25.00 + (3 * 23.00) + (copies - 5) * 20.00;
  } else {
    if (copies === 1) return 20.00;
    if (copies === 2) return 20.00 + 18.00;
    if (copies >= 3 && copies <= 5) return 20.00 + 18.00 + (copies - 2) * 15.00;
    if (copies >= 6) return 20.00 + 18.00 + (3 * 15.00) + (copies - 5) * 13.00;
  }
  
  return 0;
}

function updateElementText(id, text) {
  const element = document.getElementById(id);
  if (element) element.textContent = text;
}

function calculateCoverPrice() {
  return calculateCoverPriceForCopies(orderData.copies);
}

// Funzioni di navigazione
function nextStep(current, next) {
  document.getElementById(current).classList.remove('active');
  document.getElementById(next).classList.add('active');
  updateProgressBar(parseInt(next.split('-')[1]));
  
  if (next === 'step-summary') {
    updateSummary();
  }
}

function prevStep(current, prev) {
  document.getElementById(current).classList.remove('active');
  document.getElementById(prev).classList.add('active');
  updateProgressBar(parseInt(prev.split('-')[1]));
}

function validateMaterialStep() {
  if (!orderData.material.id || !orderData.material.color) {
    alert('Per favore, seleziona materiale e colore prima di continuare.');
    return;
  }
  nextStep('step-material', 'step-printing');
}

function validatePrintingStep() {
  const totalPagesInput = document.getElementById('total-pages-input');
  const totalPages = parseInt(totalPagesInput.value) || 0;
  
  if (totalPages === 0) {
    alert('Per favore, inserisci il numero totale di pagine della tua tesi.');
    return;
  }
  
  if (totalPages > 1000) {
    if (!confirm(`Sei sicuro che la tua tesi abbia ${totalPages} pagine? Questo numero sembra molto alto.`)) {
      return;
    }
  }
  
  if (totalPages < 10) {
    if (!confirm(`Sei sicuro che la tua tesi abbia solo ${totalPages} pagine?`)) {
      return;
    }
  }
  
  nextStep('step-printing', 'step-document');
}

function validateDocumentStep() {
  nextStep('step-document', 'step-copies');
}

function validateSummaryStep() {
  nextStep('step-summary', 'step-contact');
}

function updateProgressBar(step) {
  const progressFill = document.querySelector('.progress-fill');
  if (progressFill) {
    const percentage = (step / 6) * 100;
    progressFill.style.width = percentage + '%';
  }
  
  document.querySelectorAll('.progress-step').forEach((stepEl, index) => {
    if (index + 1 <= step) {
      stepEl.classList.add('active');
    } else {
      stepEl.classList.remove('active');
    }
  });
}

function updateSummary() {
  updateElementText('summary-material', orderData.material.name || '-');
  updateElementText('summary-color', orderData.material.color || '-');
  updateElementText('summary-print-color', getPrintColorName(orderData.printColor) || '-');
  updateElementText('summary-print-type', orderData.printType === 'solo-fronte' ? 'Solo fronte' : 'Fronte e retro');
  updateElementText('summary-internal-print', orderData.printInternal === 'bianco-nero' ? 'Bianco e nero' : 'A colori');
  updateElementText('summary-paper', orderData.paperWeight ? `${orderData.paperWeight} gr` : '-');
  updateElementText('summary-total-pages', orderData.totalPages);
  updateElementText('summary-color-pages', orderData.colorPages);
  updateElementText('summary-copies', orderData.copies);
  
  const fileNames = orderData.uploadedFiles.map(file => file.name).join(', ') || 'Nessun file';
  updateElementText('summary-files', fileNames);
}

function prepareFormSubmission(event) {
  // Validazione finale
  if (!validateContactInfo()) {
    event.preventDefault();
    return false;
  }
  
  // Popola i campi nascosti con i dati di riepilogo
  document.getElementById('hidden-total-price').value = document.getElementById('price-total').textContent;
  
  // Crea un riepilogo dettagliato
  const summaryText = `
RIEPILOGO RICHIESTA:
Materiale: ${orderData.material.name}
Colore: ${orderData.material.color}
Colore stampa: ${getPrintColorName(orderData.printColor)}
Tipo di stampa: ${orderData.printType === 'solo-fronte' ? 'Solo fronte' : 'Fronte e retro'}
Stampa interna: ${orderData.printInternal === 'bianco-nero' ? 'Bianco e nero' : 'A colori'}
Grammatura: ${orderData.paperWeight} gr
Pagine totali: ${orderData.totalPages}
Pagine a colori: ${orderData.colorPages}
Numero copie: ${orderData.copies}
File caricati: ${orderData.uploadedFiles.map(file => file.name).join(', ') || 'Nessun file'}
Spedizione: ${orderData.shippingRequired ? 'Sì' : 'No'}
  `;
  
  document.getElementById('hidden-summary').value = summaryText;
  
  // Mostra il modal di conferma
  showConfirmationModal();
  
  // Il form si invierà automaticamente
  console.log('📤 Invio form a FormSubmit...');
  return true;
}

function validateContactInfo() {
  const name = document.getElementById('customer-name').value.trim();
  const email = document.getElementById('customer-email').value.trim();
  const phone = document.getElementById('customer-phone').value.trim();
  const privacy = document.getElementById('privacy-agreement').checked;

  if (!name) {
    alert('Per favore, inserisci il tuo nome e cognome.');
    return false;
  }

  if (!email) {
    alert('Per favore, inserisci la tua email.');
    return false;
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    alert('Per favore, inserisci un indirizzo email valido.');
    return false;
  }

  if (!phone) {
    alert('Per favore, inserisci il tuo numero di telefono.');
    return false;
  }

  if (!privacy) {
    alert('Devi accettare l\'informativa sulla privacy per procedere.');
    return false;
  }

  if (orderData.shippingRequired) {
    const address = document.getElementById('shipping-address').value.trim();
    const zip = document.getElementById('shipping-zip').value.trim();
    const province = document.getElementById('shipping-province').value.trim();
    
    if (!address) {
      alert('Per favore, inserisci l\'indirizzo di spedizione.');
      return false;
    }
    
    if (!zip) {
      alert('Per favore, inserisci il CAP.');
      return false;
    }
    
    if (!province) {
      alert('Per favore, inserisci la provincia.');
      return false;
    }
  }

  return true;
}

function showConfirmationModal() {
  const modal = document.getElementById('confirmation-modal');
  modal.style.display = 'block';
  
  // Chiudi automaticamente dopo 5 secondi
  setTimeout(() => {
    closeModal();
  }, 5000);
}

function closeModal() {
  const modal = document.getElementById('confirmation-modal');
  modal.style.display = 'none';
}

function resetConfigurator() {
  closeModal();
  
  orderData = {
    material: { id: '', name: '', category: '', color: '' },
    printColor: 'oro',
    printType: 'solo-fronte',
    printInternal: 'bianco-nero',
    paperWeight: '80',
    totalPages: 0,
    colorPages: 0,
    copies: 1,
    uploadedFiles: [],
    customerName: '',
    customerEmail: '',
    customerPhone: '',
    shippingRequired: false,
    shippingAddress: '',
    shippingZip: '',
    shippingProvince: ''
  };
  
  // Resetta il form
  document.getElementById('material-category').selectedIndex = 0;
  document.getElementById('material-color').innerHTML = '<option value="">Prima seleziona il materiale</option>';
  document.getElementById('material-color').disabled = true;
  document.getElementById('print-color').value = 'oro';
  document.getElementById('total-pages-input').value = '';
  document.getElementById('color-pages-input').value = '';
  document.getElementById('copies-count').value = '1';
  document.getElementById('customer-name').value = '';
  document.getElementById('customer-email').value = '';
  document.getElementById('customer-phone').value = '';
  document.getElementById('privacy-agreement').checked = false;
  document.getElementById('shipping-required').checked = false;
  document.getElementById('shipping-address').value = '';
  document.getElementById('shipping-zip').value = '';
  document.getElementById('shipping-province').value = '';
  
  document.querySelectorAll('.shipping-fields').forEach(field => {
    field.style.display = 'none';
  });
  
  // Riabilita tutte le opzioni di colore stampa
  document.getElementById('print-color').querySelectorAll('option').forEach(option => {
    option.disabled = false;
  });
  
  orderData.uploadedFiles = [];
  updateFilesPreview();
  document.getElementById('upload-area').style.display = 'block';
  
  document.querySelector('input[name="Tipo di Stampa"][value="solo-fronte"]').checked = true;
  document.querySelector('input[name="Stampa Interna"][value="bianco-nero"]').checked = true;
  document.getElementById('paper-weight').selectedIndex = 0;
  
  updateSelectedMaterialsDisplay();
  calculatePrice();
  updateSummary();
  
  document.querySelectorAll('.config-step').forEach(step => {
    step.classList.remove('active');
  });
  document.getElementById('step-material').classList.add('active');
  updateProgressBar(1);
}

window.onclick = function(event) {
  const modal = document.getElementById('confirmation-modal');
  if (event.target === modal) {
    closeModal();
  }
}